import React, { ReactNode, memo } from 'react';

import { twMerge } from 'tailwind-merge';
import Image from 'tracking-fe/src/Components/Common/Image';

import { Copy } from '../../../atoms';

export interface IOrderInfoBlock {
  title?: ReactNode;
  value?: ReactNode;
  imgSrc?: string;
  className?: string;
  icon?: ReactNode;
  swapStyles?: boolean;
}
const OrderInfoBlock = memo(
  ({ title, value, imgSrc, className, icon, swapStyles }: IOrderInfoBlock) => {
    return (
      <div className={twMerge('flex gap-4 items-center px-4 font-inter', className)}>
        {icon && icon}
        {imgSrc && (
          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
            <Image
              src={imgSrc}
              minHeight="32px"
              minWidth="32px"
              alt="logo"
              height="32px"
              width="32px"
            />
          </div>
        )}
        <div className="flex flex-col">
          <Copy
            as="div"
            type={swapStyles ? 'copy1' : 'copy3'}
            weight={swapStyles ? 'medium' : 'regular'}
            className={twMerge(swapStyles ? 'text-v2blueGray-800' : 'text-v2blueGray-500')}
          >
            {title}
          </Copy>
          <Copy
            as="div"
            type={swapStyles ? 'copy3' : 'copy1'}
            weight={swapStyles ? 'regular' : 'medium'}
            className={twMerge(swapStyles ? 'text-v2blueGray-500' : 'text-v2blueGray-800')}
          >
            {value}
          </Copy>
        </div>
      </div>
    );
  },
);

OrderInfoBlock.displayName = 'OrderInfoBlock';

export { OrderInfoBlock };
